import { create } from "zustand";

export const useDragBackground = create((set) => ({
    draggedBackgroundSrc: null,
    draggedBackgroundOriginalSrc: null,
    draggedBackgroundFilter: 'auto',
    setDraggedBackground: (imageSrc, originalSrc, filter) => set(() => ({ draggedBackgroundSrc: imageSrc, draggedBackgroundOriginalSrc: originalSrc, draggedBackgroundFilter: filter || 'auto' })),
}));
